"use strict";
import {
  SAVING_ANNOTATIONS,
  SAVING_ANNOTATIONS_SUCCEEDED,
  SAVING_ANNOTATIONS_FAILED,
  LOADING_ANNOTATIONS,
  LOADING_ANNOTATIONS_SUCCEEDED,
  LOADING_ANNOTATIONS_FAILED,
  TOGGLE_ANNOTATING_STATUS,
  TOGGLE_TONE_SLIDERS,
  TOGGLE_CROPPING
} from "../actions";
export default function annotationModeReducer(modes = {
  annotating: false,
  saving: false,
  loading: false,
  justSaved: false,
  showToneSliders: false,
  cropping: false
}, action) {
  let {
    saving,
    annotating,
    loading,
    justSaved,
    showToneSliders,
    cropping
  } = modes;
  switch (action.type) {
    case SAVING_ANNOTATIONS:
      saving = true;
      justSaved = false;
      cropping = false;
      showToneSliders = false;
      break;
    case SAVING_ANNOTATIONS_SUCCEEDED:
      saving = false;
      annotating = false;
      cropping = false;
      justSaved = true;
      showToneSliders = false;
      break;
    case SAVING_ANNOTATIONS_FAILED:
      saving = false;
      justSaved = false;
      showToneSliders = false;
      break;
    case LOADING_ANNOTATIONS:
      loading = true;
      justSaved = false;
      showToneSliders = false;
      break;
    case LOADING_ANNOTATIONS_SUCCEEDED:
      loading = false;
      break;
    case LOADING_ANNOTATIONS_FAILED:
      loading = false;
      break;
    case TOGGLE_ANNOTATING_STATUS:
      annotating = !annotating;
      justSaved = false;
      break;
    case TOGGLE_TONE_SLIDERS:
      showToneSliders = !showToneSliders;
      break;
    case TOGGLE_CROPPING:
      cropping = !cropping;
      break;
    default:
      break;
  }
  return { saving, annotating, loading, justSaved, showToneSliders, cropping };
}
